import {configJson, getHttp} from "@/api/config/http-configs";

// 设置查询统一走终端鉴权版接口（TERMINAL token 自证租户）。
// 多租户共享 pad 入口域名时，公开版 /mobile/setting/list 依赖 Host 域名/fallback 定租户，
// 无法保证归属，因此 pad 全部使用本鉴权版（三个调用均发生在设备连接、持有 token 之后）。
const SETTING_LIST_URL = "/mobile/terminal/setting/list"

// 全部协议/须知（用户协议、隐私、签到/签离须知、访客须知）
export const getAllAgreement = () => {
    const targetList = ["ALL"]
    const typeList = ["USER_AGREEMENT", "SECRET_AGREEMENT", "VISITOR_NOTICE", "ENTER_NOTICE", "LEAVE_NOTICE"]
    return getHttp().post(SETTING_LIST_URL, {targetList, typeList}, configJson)
}

// 首页配置（系统名/欢迎语/logo/背景/入场入口/预约二维码）
// 注意 target 固定值 TERMINATE（后端枚举历史拼写，勿改）
export const getHomeSettingInfo = () => {
    const targetList = ["TERMINATE"]
    const typeList = ["HOME_WELCOME", "SYSTEM_NAME", "COMPANY_LOGO", "HOME_BACKGROUND", "HOME_ENTER_SETTING", "HOME_BANNER_LIST", "HOME_QR_REGISTER"]
    return getHttp().post(SETTING_LIST_URL, {targetList, typeList}, configJson)
}

// 访客信息配置（证件类型 CER_TYPE + 身份证等字段显隐 VISITOR_BOOK/VISITOR_INVITE）
export const getVisitorConfigSetting = () => {
    const targetList = ["VISITORINFO"]
    const typeList = ["CER_TYPE", "VISITOR_BOOK", "VISITOR_INVITE"]
    return getHttp().post(SETTING_LIST_URL, {targetList, typeList}, configJson)
}

// 员工信息配置（UNIVERSAL：searchEmployeeBy 被访员工查找方式 ALL=姓名/手机号 EMAIL=仅邮箱、
// nameSearch/phoneNoSearch 完整查询 searchTypeFull / 模糊查询 searchTypePart）
export const getEmployeeConfigSetting = () => {
    const targetList = ["EMPLOYEEINFO"]
    const typeList = ["UNIVERSAL"]
    return getHttp().post(SETTING_LIST_URL, {targetList, typeList}, configJson)
}
